// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import { message } from "antd";
// import axios from "axios";
// import PageHeader from "../../Routes/PageHeader";
// import { API, Headers } from "../../Config";
// import LoadingBox from "../../Components/LoadingBox";
// import FormModalJournal from "../VoucherScreen/formJournal";
// import FormModal from "../VoucherScreen/FormModal";
// import DataTable from "../VoucherScreen/DataTable";
// import FormModalReciept from "./FormReceipt";

// const Voucher = () => {
//   const { page_mode } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [indicator, setIndicator] = useState(false);
//   const [form, setform] = useState(false);
//   const [mode, setMode] = useState("post");
//   const [head, setHead] = useState("");
//   const [page, setPage] = useState(1);
//   const [take, setTake] = useState(10);
//   const [data, setData] = useState([]);
//   const [meta, setMeta] = useState({});
//   const [item, setItem] = useState({});
//   const [accounts, setAccounts] = useState([]);
//   const [columnsVisible, setColumnsVisible] = useState({});

//   useEffect(() => {
//     switch (page_mode) {
//       case "RV":
//         setColumnsVisible({
//           page: "Reciept Voucher",
//           short: "RV",
//           amount_cr: true,
//           amount_dr: false,
//           accounts: true,
//         });
//         break;
//       case "PV":
//         setColumnsVisible({
//           page: "Payment Voucher",
//           short: "PV",
//           amount_cr: true,
//           amount_dr: true,
//           accounts: true,
//         });
//         break;
//       case "JV":
//         setColumnsVisible({
//           page: "Journal Voucher",
//           short: "JV",
//           amount_cr: true,
//           amount_dr: true,
//           accounts: false,
//         });
//         break;
//       default:
//         break;
//     }
//     loaddata(page, take);
//     AccountsDropdown();
//   }, []);

//   const loaddata = (p, t) => {
//     axios
//       .get(
//         API.BASR_URL +
//           API.VOUCHER_LIST +
//           `/${page_mode}?order=DESC&page=${p}&take=${t}`,
//         {
//           headers: Headers(),
//         }
//       )
//       .then(function (response) {
//         if (response.status === 200) {
//           let data = response.data;
//           setData(data.data);
//           setMeta(data.meta);
//           message.success("Success");
//         } else {
//           message.error("Oops.Something went wrong");
//         }
//         setLoading(false);
//         setIndicator(false);
//       })
//       .catch(function (error) {
//         message.error("Oops.Something went wrong");
//         setIndicator(false);
//         setLoading(false);
//       });
//   };

//   const AccountsDropdown = () => {
//     axios
//       .get(API.BASR_URL + API.CHART_OF_ACCOUNTS_LIST + `/child_accounts`, {
//         headers: Headers(),
//       })
//       .then(function (res) {
//         if (res.status === 200) setAccounts(res.data);
//       })
//       .catch(function (error) {
//         message.error("Customers dropdown faild");
//       });
//   };

//   const pagination = (page, take) => {
//     window.scrollTo(0, 0);
//     setIndicator(true);
//     setPage(page);
//     setTake(take);
//     loaddata(page, take);
//   };

//   const relaod = () => {
//     loaddata(page, take);
//     setMode("post");
//     setItem({});
//     setform(false);
//   };

//   const AddItem = () => {
//     setMode("post");
//     setItem({});
//     setform(true);
//   };

//   const UpdateItem = (item) => {
//     setMode("put");
//     setItem(item);
//     setform(true);
//   };

//   const DeleteItem = (item) => {
//     setIndicator(true);
//     axios
//       .delete(API.BASR_URL + API.VOUCHER_ACTIONS + item.id, {
//         headers: Headers(),
//       })
//       .then(function (response) {
//         setIndicator(false);
//         message.success("Deleted Successfully");
//         relaod();
//       })
//       .catch(function (error) {
//         setIndicator(false);
//         message.error("Oops.Something went wrong");
//         console.log(error);
//       });
//   };

//   return (
//     <div>
//       <PageHeader
//         PageName={head}
//         breadScrum={`Admin / ${columnsVisible.page}`}
//         RightButton={`New / ${columnsVisible.page}`}
//         RightClcik={() => AddItem()}
//         loader={indicator}
//       />
//       {loading ? (
//         <LoadingBox />
//       ) : (
//         <div>
//           <DataTable
//             columnsVisible={columnsVisible}
//             meta={meta}
//             data={data}
//             update={(item) => UpdateItem(item)}
//             delete={(item) => DeleteItem(item)}
//             PageOnchange={(page, take) => pagination(page, take)}
//           />

//           {form && page_mode === "RV" && (
//             <FormModalReciept
//               page_mode={page_mode}
//               accounts={accounts}
//               head={head}
//               item={item}
//               mode={mode}
//               visible={form}
//               columnsVisible={columnsVisible}
//               onchange={() => relaod()}
//               onClose={() => setform(false)}
//             />
//           )}
//           {form && page_mode === "PV" && (
//             <FormModal
//               page_mode={page_mode}
//               accounts={accounts}
//               head={head}
//               item={item}
//               mode={mode}
//               visible={form}
//               columnsVisible={columnsVisible}
//               onchange={() => relaod()}
//               onClose={() => setform(false)}
//             />
//           )}

//           {form && page_mode === "JV" && (
//             <FormModalJournal
//               page_mode={page_mode}
//               accounts={accounts}
//               head={head}
//               item={item}
//               mode={mode}
//               visible={form}
//               columnsVisible={columnsVisible}
//               onchange={() => relaod()}
//               onClose={() => setform(false)}
//             />
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Voucher;

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { message, Input } from "antd"; // Import Input for search
import axios from "axios";
import PageHeader from "../../Routes/PageHeader";
import { API, Headers } from "../../Config";
import LoadingBox from "../../Components/LoadingBox";
import FormModalJournal from "../VoucherScreen/formJournal";
import FormModal from "../VoucherScreen/FormModal";
import DataTable from "../VoucherScreen/DataTable";
import FormModalReciept from "./FormReceipt";

const Voucher = () => {
  const { page_mode } = useParams();
  const [loading, setLoading] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [form, setform] = useState(false);
  const [mode, setMode] = useState("post");
  const [head, setHead] = useState("");
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10); // Corrected state declaration
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [item, setItem] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [columnsVisible, setColumnsVisible] = useState({});
  const [searchTerm, setSearchTerm] = useState(""); // State for search term

  useEffect(() => {
    switch (page_mode) {
      case "RV":
        setColumnsVisible({
          page: "Receipt Voucher",
          short: "RV",
          amount_cr: true,
          amount_dr: false,
          accounts: true,
        });
        break;
      case "PV":
        setColumnsVisible({
          page: "Payment Voucher",
          short: "PV",
          amount_cr: true,
          amount_dr: true,
          accounts: true,
        });
        break;
      case "JV":
        setColumnsVisible({
          page: "Journal Voucher",
          short: "JV",
          amount_cr: true,
          amount_dr: true,
          accounts: false,
        });
        break;
      default:
        break;
    }
    loaddata(page, take, searchTerm); // Call loaddata with searchTerm
    AccountsDropdown();
  }, [page_mode, searchTerm]); // Add searchTerm to dependencies

  const loaddata = (p, t, search = "") => {
    const url = `${API.BASR_URL}${
      API.VOUCHER_LIST
    }/${page_mode}?order=DESC&page=${p}&take=${t}${
      search ? `&search=${search}` : ""
    }`;
    axios
      .get(url, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = response.data;
          setData(data.data);
          setMeta(data.meta);
          message.success("Success");
        } else {
          message.error("Oops. Something went wrong");
        }
        setLoading(false);
        setIndicator(false);
      })
      .catch(function (error) {
        message.error("Oops. Something went wrong");
        setIndicator(false);
        setLoading(false);
      });
  };

  const AccountsDropdown = () => {
    axios
      .get(API.BASR_URL + API.CHART_OF_ACCOUNTS_LIST + `/child_accounts`, {
        headers: Headers(),
      })
      .then(function (res) {
        if (res.status === 200) setAccounts(res.data);
      })
      .catch(function (error) {
        message.error("Customers dropdown failed");
      });
  };

  const pagination = (page, take) => {
    window.scrollTo(0, 0);
    setIndicator(true);
    setPage(page);
    setTake(take);
    loaddata(page, take, searchTerm); // Pass searchTerm to loaddata
  };

  const relaod = () => {
    loaddata(page, take, searchTerm); // Pass searchTerm to loaddata
    setMode("post");
    setItem({});
    setform(false);
  };

  const AddItem = () => {
    setMode("post");
    setItem({});
    setform(true);
  };

  const UpdateItem = (item) => {
    setMode("put");
    setItem(item);
    setform(true);
  };

  const DeleteItem = (item) => {
    setIndicator(true);
    axios
      .delete(API.BASR_URL + API.VOUCHER_ACTIONS + item.id, {
        headers: Headers(),
      })
      .then(function (response) {
        setIndicator(false);
        message.success("Deleted Successfully");
        relaod();
      })
      .catch(function (error) {
        setIndicator(false);
        message.error("Oops. Something went wrong");
        console.log(error);
      });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(1); // Reset to first page on search
  };

  return (
    <div>
      <PageHeader
        PageName={head}
        breadScrum={`Admin / ${columnsVisible.page}`}
        RightButton={`New / ${columnsVisible.page}`}
        RightClcik={() => AddItem()}
        loader={indicator}
      />
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Search by Airway Bill Number"
          value={searchTerm}
          onChange={handleSearch}
          style={{ width: 300 }}
        />
      </div>
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <DataTable
            columnsVisible={columnsVisible}
            meta={meta}
            data={data}
            update={(item) => UpdateItem(item)}
            delete={(item) => DeleteItem(item)}
            PageOnchange={(page, take) => pagination(page, take)}
          />

          {form && page_mode === "RV" && (
            <FormModalReciept
              page_mode={page_mode}
              accounts={accounts}
              head={head}
              item={item}
              mode={mode}
              visible={form}
              columnsVisible={columnsVisible}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          )}
          {form && page_mode === "PV" && (
            <FormModal
              page_mode={page_mode}
              accounts={accounts}
              head={head}
              item={item}
              mode={mode}
              visible={form}
              columnsVisible={columnsVisible}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          )}

          {form && page_mode === "JV" && (
            <FormModalJournal
              page_mode={page_mode}
              accounts={accounts}
              head={head}
              item={item}
              mode={mode}
              visible={form}
              columnsVisible={columnsVisible}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Voucher;
